import { connect } from 'react-redux';
import * as actions from './actions';
import SignUp from './SignUp';

const mapStateToProps = (state, ownProps) => {
  return {
    isSigningIn: state.signup.isSigningIn,
    signupStatus: state.signup.signupStatus,
    loginStatus: state.login.loginStatus,
    user: state.login.user,
    hasErrorOccured: state.signup.hasErrorOccured,
    errors: state.signup.errors,
    ...ownProps
  };
};

const mapDispatchToProps = dispatch => ({
  signupUser: (email, password, name, plan, domain_url,fvlite_role,phone_number,companyName) =>
    dispatch(actions.signupUser(email, password, name, plan, domain_url,fvlite_role,phone_number,companyName)),
  recieveSignupstatus: (bool, user) =>
    dispatch(actions.recieveSignupstatus(bool, user)),
  authErrors: errors => dispatch(actions.authErrors(errors))
});

const LoginContainer = connect(mapStateToProps, mapDispatchToProps)(SignUp);

export default LoginContainer;


// WEBPACK FOOTER //
// src/routes/SignUp/SignUpContainer.js